<template>
  <router-view />
  <MsgErrosAxios />
</template>

<script>
import { store } from "@/store/store";
import { getData } from "@/services/apiService";
import MsgErrosAxios from "./components/MsgErrosAxios.vue";
import { iniciarSessaoLog } from "@/utils/pedidoLogger.js";

export default {
  data() {
    return {
      store,
    };
  },
  async mounted() {
    // Inicializar sessão de logs
    await iniciarSessaoLog();

    // Heartbeat
    if (!this.store.licencaTeste) {
      this.intervaloHB = setInterval(this.enviarHeartBeat, 120000); // intervalo: 2 minutos
      this.enviarHeartBeat();
    }
  },
  methods: {
    async enviarHeartBeat() {
      if (sessionStorage.getItem("fluxus_mobile_token")) {
        const url = `${this.$urlBackend}/api/v1/heartBeat`;
        await getData(url);
      }
    },
  },
  components: {
    MsgErrosAxios,
  },
};
</script>

<style>
#app {
  font-family: "Montserrat", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
